import CreditCardUpdate from './components/account-credit-card-update.vue';
import UpdateProfile from './components/account-update-profile.vue';
import AccountPreferences from './components/account-preferences.vue';
import Goals from './components/goal-settings.vue';
import SavedData from './components/account-saved-data.vue';
import Referral from './components/account-referral.vue';

window.vueAccount = new Vue({

    name: 'Account',
    el: '#account-app',
    data: {

        section: window.coreVariables.getParameterByName('lc-section') ? window.coreVariables.getParameterByName('lc-section') : 'profile',

    },

    components: {

        CreditCardUpdate,
        UpdateProfile,
        AccountPreferences,
        Goals,
        SavedData,
        Referral

    },

    methods: {

        changeSection(section) {

            if(section === 'contact'){

                document.getElementById('profile-contact').style.display = 'block';

            }
            else {

                document.getElementById('profile-contact').style.display = 'none';

            }

            this.section = section;


        }
    },

    mounted() {


        jQuery('#account-menu a').click(function(){

            jQuery('#loading-bar').show();

        });

        //deal with safari state caching
        window.addEventListener('pageshow', function(){

            jQuery('#loading-bar').hide();

        })

    }

});